import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
let global_db3 = null;


export const initializeFSTORE3 = () =>{
    const app3 = initializeApp({
        apiKey: "AIzaSyDa9miLs1ndtVORKfbWwSq_SAesHkhmJrk",
        authDomain: "isd-shopify-helper.firebaseapp.com",
        projectId: "isd-shopify-helper",
        storageBucket: "isd-shopify-helper.appspot.com",
        messagingSenderId: "441212102733",
        appId: "1:441212102733:web:1a5b120bcbe86a62329404",
        measurementId: "G-3QEZEBFD3H"
    },"app3");
    const db3 = getFirestore(app3)
    global_db3 = db3
    return global_db3
}

export const get_global_db_3 = () => {
    return global_db3
}